module.exports = __webpack_public_path__ + "img/product-mobile2.d01ac037.png";